import React from "react";
// import { useSsrEffect } from "@issr/core";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Button } from "reactstrap";
import { useWeb3React } from "@web3-react/core";
// import Page from "../../components/Page";
import {
  mintingInProgressSuccess,
  genericAbiWrite,
  mintError,
  transactionSuccess,
  // mintErrorReset,
} from "@bkry/bowline-redux/contracts";
import { claimRewardsAbi } from "@bkry/bowline-components/Staking";

/**
 * TokenDetail container used as app default landing page
 */
const ClaimButton = ({ stakingContract }, context) => {
  //  const { contentId } = useParams();
  const dispatch = useDispatch();
  const { account, provider } = useWeb3React();

  const handleClaiming = async () => {
    dispatch(
      genericAbiWrite({
        functionAbi: claimRewardsAbi,
        contractAddress: stakingContract,
        account: account,
        provider: provider,
        successCallbackFnc: (data) => {
          console.log("success Data", data);
          dispatch(mintingInProgressSuccess(data));
        },
        errorCallbackFnc: (data) => {
          console.log("error Data", data);
          dispatch(mintError(data));
        },
        transactionCallbackFnc: (data) => {
          console.log("transfer data", data);
          // toggleTransferModal();
          dispatch(transactionSuccess(data));
        },
      })
    );
  };

  return (
    <div className="my-3 d-grid gap-2 col-sm-12 mx-auto">
      <Button
        className="fw-bold"
        color="primary"
        onClick={handleClaiming}
        outline
        // disabled={!isValid}
      >
        {context.t("Claim")}
      </Button>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
ClaimButton.contextTypes = {
  t: PropTypes.func,
};

ClaimButton.propTypes = {
  stakingContract: PropTypes.string,
};

/** export the component as redux connected component */
export default ClaimButton;
